import {
  MoveWithUsChangeOfTenancyStatus,
  type MoveWithUsChangeOfTenancy,
} from "@/api/model"
import { parseApiDate, today } from "@/lib/dateHelper"

// The record stays SUCCESSFUL after the move, so only the move-in date ends it.
export const isMoveWithUsInFlight = (record?: MoveWithUsChangeOfTenancy) =>
  !!record &&
  (record.status === MoveWithUsChangeOfTenancyStatus.FAILED ||
    (parseApiDate(record.moveInDate)?.isAfter(today(), "day") ?? false))

export const describeMoveOut = (addressLine1?: string) =>
  addressLine1 ? `You're moving out of ${addressLine1}` : "You're moving out"
